import { IAM_CONTRACT, TWU_CONTRACT } from "../constants";
import { processRow, processHeader, downloadCSV } from "../csvUtils";
import { getUnionContractGivenWorkgroup } from "../workgroupMapper";
import { getFormattedProjectedFtoBalance, getFormattedProjectedVacationBalance } from "./declarationUtils";

export function exportToCsv({ filename, rows, station, workgroup }) {
  var csvFile = "";
  for (var i = 0; i < rows.length; i++) {
    const currentRowToProcess = scrubDeclarationRowForExport({
      declartionRow: rows[i],
      station,
      workgroup,
    });
    if (i === 0) {
      csvFile += processHeader(currentRowToProcess);
    }
    csvFile += processRow(currentRowToProcess);
  }

  downloadCSV(csvFile, filename);
}

const renderNameCell = (declartionRow, station) => {
  let name = declartionRow["lastName"] + ", " + declartionRow["shortName"];

  if (declartionRow["isTemp"] && declartionRow["homeStation"] !== station) {
    name += " (Temp)";
  }

  return name;
};

const scrubDeclarationRowForExport = ({ declartionRow, station, workgroup }) => {
  const scrubbedDeclartionRow = {
    EID: declartionRow["eid"],
    Name: renderNameCell(declartionRow, station),
    "FT/PT": declartionRow["ftpt"],
    "Hire Date": declartionRow["hireDate"],
  };
  const userContract = getUnionContractGivenWorkgroup(workgroup);
  if (userContract === IAM_CONTRACT) {
    scrubbedDeclartionRow["Projected Vacation Weeks"] = declartionRow["projectedVacationBalance"]
      ? getFormattedProjectedVacationBalance(
          userContract,
          declartionRow["ftpt"],
          declartionRow["projectedVacationBalance"]
        )
      : "";
    scrubbedDeclartionRow["DAT Weeks Count"] = declartionRow["datWeeksCount"];
    scrubbedDeclartionRow["Block Weeks Count"] = declartionRow["blockWeeksCount"];
  } else if (userContract === TWU_CONTRACT) {
    scrubbedDeclartionRow["Projected Vacation Weeks"] = declartionRow["projectedVacationBalance"]
      ? getFormattedProjectedVacationBalance(
          userContract,
          declartionRow["ftpt"],
          declartionRow["projectedVacationBalance"]
        )
      : "";
    scrubbedDeclartionRow["Projected FTO Days"] = declartionRow["projectedFtoBalance"]
      ? getFormattedProjectedFtoBalance(declartionRow["projectedFtoBalance"])
      : "";
    scrubbedDeclartionRow["DAT Weeks Declared"] = declartionRow["datWeeksCount"] ? declartionRow["datWeeksCount"] : "";
    scrubbedDeclartionRow["Block Weeks Declared"] = declartionRow["blockWeeksCount"]
      ? declartionRow["blockWeeksCount"]
      : "";
    scrubbedDeclartionRow["Freeday/FTO"] = declartionRow["declaration"] ? declartionRow["declaration"] : "";
  }
  scrubbedDeclartionRow["Comments"] =
    declartionRow["flags"] && declartionRow["flags"]["isAdminCreated"] === true && declartionRow["comments"]
      ? declartionRow["comments"]
      : "";

  return scrubbedDeclartionRow;
};

export const generateExportedFilename = ({ station, workgroup, declarationYear }) => {
  let underScoredWorkgroup = workgroup.split(" ").join("_");

  return `STARS_${station}_${underScoredWorkgroup}_Declarations_${declarationYear}.csv`;
};

export function exportBlankCsv({ filename, unionContract, station, workgroup }) {
  var csvFile = "";
  const header =
    unionContract === TWU_CONTRACT
      ? { EID: "", "Projected Vacation Hours": "", "Projected FTO Hours": "" }
      : { EID: "", "Projected Vacation Hours": "" };
  csvFile += processHeader(header);
  downloadCSV(csvFile, filename);
}

export const generateExportedFilenameForBlankDeclarationCsv = ({ unionContract }) => {
  return `STARS_${unionContract}_Declaration_Balances_Template.csv`;
};
